import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from 'styled-components';
import transition from 'styled-transition-group';
import fp from 'lodash/fp';
import { connect } from 'react-redux';
import { size, media, mapState } from '@deerplusofficial/pos-helper';
import { withClientProvider } from '@deerplusofficial/pos-hoc';
import withResetPos from '../../assist/withResetPos';
import withTopbar from '../../assist/withTopbar';
import withChannelGuard from '../../assist/withChannelGuard';
import { withQueryChannel } from '../../model/Queries';
import {
  Cart,
  Container,
  DiscountModal,
  ProductLine,
  CheckoutPanel,
  ProductModal,
  InvoiceModal,
  PageTitle,
} from '../../components';

const DURATION = 800;

const ProductLineTransition = transition.div.attrs({
  timeout: {
    enter: 0,
    exit: DURATION,
  },
  unmountOnExit: true,
})`
  display: ${props => (props.active ? 'flex' : 'none')};
  flex-grow: 1;
  ${media(
    'tablet',
    css`
      transition: opacity ${(DURATION / 1000) * 0.8}s ease-in-out,
        max-width ${DURATION / 1000}s ease-in-out;
    `
  )}
  &:exit {
    ${media(
      'tablet',
      css`
        display: flex;
        max-width: calc(100% - ${size.cart});
      `
    )}
  }
  &:exit-active {
    ${media(
      'tablet',
      css`
        opacity: 0;
        max-width: 0;
        overflow: hidden;
      `
    )}
  }
`;

const CheckoutPanelTransition = transition.div.attrs({
  timeout: {
    enter: DURATION,
    exit: 0,
  },
  mountOnEnter: true,
  unmountOnExit: true,
})`
  display: ${props => (props.active ? 'flex' : 'none')};
  flex-grow: 1;
  ${media(
    'tablet',
    css`
      order: 1;
      transition: max-width ${DURATION / 1000}s ease-in-out;
    `
  )}
  &:enter {
    ${media(
      'tablet',
      css`
        max-width: 0;
        overflow: hidden;
      `
    )}
  }
  &:enter-active {
    ${media(
      'tablet',
      css`
        max-width: calc(100% - ${size.cart});
      `
    )}
  }
`;

class Main extends Component {
  static propTypes = {
    orderStep: PropTypes.string,
  };

  static defaultProps = {
    orderStep: 'order',
  };

  get isCheckout() {
    return /(checkout|done)/.test(this.props.orderStep);
  }

  get isShowCart() {
    const { orderDetail, cart } = this.props;

    if (this.isCheckout) return orderDetail.active;

    return cart.active;
  }

  render() {
    const { orderStep } = this.props;

    return (
      <React.Fragment>
        <PageTitle>POS</PageTitle>
        <Container>
          <CheckoutPanelTransition
            active={this.isCheckout}
            in={this.isCheckout}
          >
            <CheckoutPanel />
          </CheckoutPanelTransition>
          <ProductLineTransition
            active={!this.isCheckout}
            in={!this.isCheckout}
          >
            <ProductLine />
          </ProductLineTransition>
          {orderStep === 'done' ? (
            <InvoiceModal />
          ) : (
            <React.Fragment>
              <Cart active={this.isShowCart} readonly={this.isCheckout} />
              <DiscountModal />
            </React.Fragment>
          )}
        </Container>
        <ProductModal />
      </React.Fragment>
    );
  }
}

export default fp.compose(
  withClientProvider(),
  withTopbar(),
  withChannelGuard(),
  withQueryChannel(),
  withResetPos(),
  connect(mapState(['orderStep', 'orderDetail', 'cart']))
)(Main);



// WEBPACK FOOTER //
// ./src/pages/Main/Main.js